<template>
  <div class="log-trace">
    <div class="log-item" v-for="logItem in list" :key="logItem.id">
      <div class="log-content">{{logItem.time}} {{ logItem.content }}</div>
      <div class="dot"></div>
      <div class="line-top"></div>
      <div class="line-bottom"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';
.log-trace {
  .log-item {
    position: relative;
    display: flex;
    padding:10px 40px;
    line-height: 20px;
    .log-time {
      width: 40px;
      margin-right: 15px;
    }
    .log-content {
      margin: 0 10px;
    }
    .dot {
      position: absolute;
      top: calc(20px - 6px);
      left: 29px;
      width: 8px;
      height: 8px;
      background-color: #fff;
      border-radius: 50%;
      border: 2px solid $info;
      z-index: 20;
    }
    .line-top, .line-bottom {
      position: absolute;
      left: 34px; // dot left + 5px;
      border-left: 2px solid #e4e7ed;
      z-index: 10;
    }
    .line-top {
      top: 0px;
      height: 20px;
    }
    .line-bottom {
      top: 20px;
      height: calc(100% - 20px);
    }
    &:first-child {
      .line-top {
        display: none;
      }
    }
    &:last-child {
      .line-bottom {
        display: none;
      }
    }
  }
}
</style>
